import { VehicleValuationStatus } from "@/api-schema-enums";
import { VEHICLE_VALUATION_STATUS_TRANSLATIONS } from "@/components/vehicle-valuation/vehicle-valuation-status-translations";
import { BaseFilterProps, Filter, FilterData } from "../_types";
import { FilterComponent } from "../base-filter";

const VEHICLE_VALUATION_STATUS_VALUES = [
  VehicleValuationStatus.Failed,
  VehicleValuationStatus.OverhaulNeeded,
  VehicleValuationStatus.VehicleSelectionRequired,
  VehicleValuationStatus.WaitingForConfirmation,
  VehicleValuationStatus.InProgress,
  VehicleValuationStatus.Confirmed,
] as const satisfies readonly VehicleValuationStatus[];

const VEHICLE_VALUATION_STATUS_FILTER_OPTIONS: { id: VehicleValuationStatus; name: string }[] =
  VEHICLE_VALUATION_STATUS_VALUES.map((status) => ({
    id: status,
    name: VEHICLE_VALUATION_STATUS_TRANSLATIONS[status],
  }));

export class VehicleValuationStatusFilter extends Filter<Record<string, never>, Record<string, never>> {
  readonly id: string = "statuses";
  readonly labelSingular = "common:Status";
  readonly labelPlural = "common:Status";
  readonly placeholder = "fab:SelectVehicleValuationStatus";
  readonly searchPlaceholder = "fab:SearchVehicleValuationStatus";
  readonly emptyText = "fab:NoVehicleValuationStatusFound";
  body = {};
  parameters = {};

  constructor({ id }: { id?: string } = {}) {
    super();
    if (id) this.id = id;
  }

  getData(): FilterData {
    return {
      options: VEHICLE_VALUATION_STATUS_FILTER_OPTIONS,
      isLoading: false,
      error: null,
    };
  }

  render(props: BaseFilterProps) {
    return <FilterComponent filter={this} {...props} />;
  }
}
